
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white">
      {/* Header */}
      <header className="relative z-50">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            {/* Logo and Brand */}
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-14 h-14 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/dcd65f13a790094d0aa5adf5c5f61db5/d92e14626dcee2662ced5b45bc6a77f4.png"
                  alt="Tactical Arms Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">Tactical Arms</h1>
                <p className="text-sm text-gray-300">NXT Cam Properties • Firearms • Ammunition • Tactical Gear</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-yellow-400 font-medium border-b-2 border-yellow-400 pb-1">
                Home
              </Link>
              <Link to="/official-discounts" className="text-gray-300 hover:text-white transition-colors">
                Official Discounts
              </Link>
              <Link to="/shop" className="text-gray-300 hover:text-white transition-colors">
                Shop
              </Link>
              <Link to="/employee-application" className="text-gray-300 hover:text-white transition-colors">
                Employee Application
              </Link>
              <Link to="/employment-list" className="text-gray-300 hover:text-white transition-colors">
                Employment List
              </Link>
              <div className="relative group">
                <button className="text-gray-300 hover:text-white transition-colors flex items-center space-x-1">
                  <span>Blacklists</span>
                  <i className="ri-arrow-down-s-line"></i>
                </button>
                <div className="absolute top-full left-0 mt-2 w-64 bg-gray-800 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                  <div className="py-2">
                    <Link to="/blacklists/player-blacklists" className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700 transition-colors">
                      Player Blacklists
                    </Link>
                    <Link to="/blacklists/business-mafia-blacklists" className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700 transition-colors">
                      Business/Mafia Blacklists
                    </Link>
                  </div>
                </div>
              </div>
            </nav>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-white hover:text-yellow-400 transition-colors"
            >
              <i className={`text-xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="lg:hidden mt-4 bg-gray-800 rounded-lg p-4">
              <nav className="flex flex-col space-y-3">
                <Link to="/" className="text-yellow-400 font-medium py-2">
                  Home
                </Link>
                <Link to="/official-discounts" className="text-gray-300 hover:text-white transition-colors py-2">
                  Official Discounts
                </Link>
                <Link to="/shop" className="text-gray-300 hover:text-white transition-colors py-2">
                  Shop
                </Link>
                <Link to="/employee-application" className="text-gray-300 hover:text-white transition-colors py-2">
                  Employee Application
                </Link>
                <Link to="/employment-list" className="text-gray-300 hover:text-white transition-colors py-2">
                  Employment List
                </Link>
                <div className="border-t border-gray-700 pt-3 mt-3">
                  <p className="text-gray-400 text-sm mb-2">Blacklists</p>
                  <Link to="/blacklists/player-blacklists" className="text-gray-300 hover:text-white transition-colors py-2 pl-4 block">
                    Player Blacklists
                  </Link>
                  <Link to="/blacklists/business-mafia-blacklists" className="text-gray-300 hover:text-white transition-colors py-2 pl-4 block">
                    Business/Mafia Blacklists
                  </Link>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section 
        className="relative min-h-[600px] flex items-center justify-start bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/db43b65d1e3bff2cba5d2204160a0af3.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-2xl">
            <h2 className="text-5xl lg:text-6xl font-bold text-yellow-400 mb-6">
              Tactical. Professional. Reliable.
            </h2>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Tactical Arms by NXT Cam Properties provides high-quality firearms, ammunition, and tactical gear for professionals and enthusiasts alike. Trusted by law enforcement, military, and civilian shooters worldwide.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link 
                to="/shop" 
                className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-4 px-8 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                Browse Catalog
              </Link>
              <Link 
                to="/official-discounts" 
                className="border-2 border-yellow-400 text-yellow-400 hover:bg-yellow-400 hover:text-black font-bold py-4 px-8 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                View Discounts
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Product Categories */}
      <section className="py-20 bg-gray-900/50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-white mb-4">Our Product Categories</h3>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Explore our comprehensive selection of premium firearms, ammunition, and tactical equipment designed for professionals and enthusiasts.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Firearms */}
            <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-8 hover:bg-gray-800/70 transition-all duration-300 hover:transform hover:-translate-y-2 cursor-pointer group">
              <div className="mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20tactical%20firearms%20collection%20handguns%20rifles%20shotguns%20displayed%20on%20clean%20white%20background%20modern%20tactical%20weapons%20high%20quality%20precision%20firearms%20showcase%20tactical%20arms%20equipment&width=400&height=250&seq=firearms002&orientation=landscape"
                  alt="Firearms Collection"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              <h4 className="text-2xl font-bold text-yellow-400 mb-4 group-hover:text-yellow-300 transition-colors">
                Firearms
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Handguns, rifles, and shotguns from top manufacturers. Each weapon is engineered for accuracy, durability, and reliable performance in any situation.
              </p>
              <Link 
                to="/shop" 
                className="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-medium transition-colors"
              >
                View Firearms
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>

            {/* Ammunition */}
            <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-8 hover:bg-gray-800/70 transition-all duration-300 hover:transform hover:-translate-y-2 cursor-pointer group">
              <div className="mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Premium%20tactical%20ammunition%20collection%20various%20calibers%20bullets%20cartridges%20organized%20display%20clean%20white%20background%20professional%20ammunition%20showcase%20high%20quality%20rounds%20tactical%20arms&width=400&height=250&seq=ammo002&orientation=landscape"
                  alt="Ammunition Collection"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              <h4 className="text-2xl font-bold text-yellow-400 mb-4 group-hover:text-yellow-300 transition-colors">
                Ammunition
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Premium ammunition for range practice, hunting, and tactical applications. Consistent performance and reliability you can count on every time.
              </p>
              <Link 
                to="/shop" 
                className="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-medium transition-colors"
              >
                View Ammunition
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>

            {/* Tactical Gear */}
            <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-8 hover:bg-gray-800/70 transition-all duration-300 hover:transform hover:-translate-y-2 cursor-pointer group">
              <div className="mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Tactical%20gear%20equipment%20collection%20optics%20scopes%20accessories%20holsters%20tactical%20vests%20clean%20white%20background%20professional%20military%20equipment%20showcase%20tactical%20arms%20gear&width=400&height=250&seq=tactical002&orientation=landscape"
                  alt="Tactical Gear Collection"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              <h4 className="text-2xl font-bold text-yellow-400 mb-4 group-hover:text-yellow-300 transition-colors">
                Tactical Gear
              </h4>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Optics, accessories, and equipment designed for comfort, precision, and operational readiness. Professional-grade gear for serious users.
              </p>
              <Link 
                to="/shop" 
                className="inline-flex items-center text-yellow-400 hover:text-yellow-300 font-medium transition-colors"
              >
                View Tactical Gear
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-black/30">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-white mb-4">Why Choose Tactical Arms</h3>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              We're committed to providing the highest quality products and exceptional service to our customers.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-black"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-3">Licensed & Certified</h4>
              <p className="text-gray-300">
                Fully licensed firearms dealer with all required certifications and compliance standards.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-2xl text-black"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-3">Premium Quality</h4>
              <p className="text-gray-300">
                Only the finest products from trusted manufacturers known for excellence and reliability.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-black"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-3">Expert Support</h4>
              <p className="text-gray-300">
                Knowledgeable staff ready to help you find the right equipment for your specific needs.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-2xl text-black"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-3">Secure Shipping</h4>
              <p className="text-gray-300">
                Safe, secure, and compliant shipping to authorized dealers and qualified customers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-yellow-600 to-yellow-500">
        <div className="container mx-auto px-4 text-center">
          <h3 className="text-4xl font-bold text-black mb-6">
            Ready to Upgrade Your Arsenal?
          </h3>
          <p className="text-xl text-black/80 mb-8 max-w-2xl mx-auto">
            Browse our extensive catalog of firearms, ammunition, and tactical gear. Professional quality equipment for serious users.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/shop" 
              className="bg-black text-yellow-400 hover:bg-gray-900 font-bold py-4 px-8 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              Shop Now
            </Link>
            <Link 
              to="/employee-application" 
              className="border-2 border-black text-black hover:bg-black hover:text-yellow-400 font-bold py-4 px-8 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              Join Our Team
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center">
                  <img 
                    src="https://static.readdy.ai/image/dcd65f13a790094d0aa5adf5c5f61db5/d92e14626dcee2662ced5b45bc6a77f4.png"
                    alt="Tactical Arms Logo"
                    className="w-full h-full object-contain"
                  />
                </div>
                <span className="text-xl font-bold text-white">Tactical Arms</span>
              </div>
              <p className="text-gray-400 leading-relaxed">
                Your trusted source for premium firearms, ammunition, and tactical equipment. A division of NXT Cam Properties.
              </p>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/shop" className="text-gray-400 hover:text-yellow-400 transition-colors">Shop</Link></li>
                <li><Link to="/official-discounts" className="text-gray-400 hover:text-yellow-400 transition-colors">Discounts</Link></li>
                <li><Link to="/employee-application" className="text-gray-400 hover:text-yellow-400 transition-colors">Careers</Link></li>
                <li><Link to="/employment-list" className="text-gray-400 hover:text-yellow-400 transition-colors">Employment</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Blacklists</h4>
              <ul className="space-y-2">
                <li><Link to="/blacklists/player-blacklists" className="text-gray-400 hover:text-yellow-400 transition-colors">Player Blacklists</Link></li>
                <li><Link to="/blacklists/business-mafia-blacklists" className="text-gray-400 hover:text-yellow-400 transition-colors">Business/Mafia Blacklists</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Contact Info</h4>
              <div className="space-y-2 text-gray-400">
                <p>Licensed Firearms Dealer</p>
                <p>Professional Grade Equipment</p>
                <p>NXT Cam Properties</p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Tactical Arms - NXT Cam Properties. All rights reserved.
            </p>
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
